__turbopack_context__.v({
  "activeEdge": "AutomationsModule-module__OHvQ-q__activeEdge",
  "activeNode": "AutomationsModule-module__OHvQ-q__activeNode",
  "aiCard": "AutomationsModule-module__OHvQ-q__aiCard",
  "aiGrid": "AutomationsModule-module__OHvQ-q__aiGrid",
  "aiIcon": "AutomationsModule-module__OHvQ-q__aiIcon",
  "badge": "AutomationsModule-module__OHvQ-q__badge",
  "bubble": "AutomationsModule-module__OHvQ-q__bubble",
  "bubbleBot": "AutomationsModule-module__OHvQ-q__bubbleBot",
  "bubbleBtn": "AutomationsModule-module__OHvQ-q__bubbleBtn",
  "bubbleIn": "AutomationsModule-module__OHvQ-q__bubbleIn",
  "bubbleOut": "AutomationsModule-module__OHvQ-q__bubbleOut",
  "bubbleSystem": "AutomationsModule-module__OHvQ-q__bubbleSystem",
  "cameraDot": "AutomationsModule-module__OHvQ-q__cameraDot",
  "canvasContainer": "AutomationsModule-module__OHvQ-q__canvasContainer",
  "container": "AutomationsModule-module__OHvQ-q__container",
  "darkSection": "AutomationsModule-module__OHvQ-q__darkSection",
  "dynamicIsland": "AutomationsModule-module__OHvQ-q__dynamicIsland",
  "featureGlow": "AutomationsModule-module__OHvQ-q__featureGlow",
  "firstNode": "AutomationsModule-module__OHvQ-q__firstNode",
  "flowEdge": "AutomationsModule-module__OHvQ-q__flowEdge",
  "flowNode": "AutomationsModule-module__OHvQ-q__flowNode",
  "flowSplit": "AutomationsModule-module__OHvQ-q__flowSplit",
  "followUpSection": "AutomationsModule-module__OHvQ-q__followUpSection",
  "fuAlert": "AutomationsModule-module__OHvQ-q__fuAlert",
  "fuCard": "AutomationsModule-module__OHvQ-q__fuCard",
  "fuTag": "AutomationsModule-module__OHvQ-q__fuTag",
  "fuText": "AutomationsModule-module__OHvQ-q__fuText",
  "fuVisual": "AutomationsModule-module__OHvQ-q__fuVisual",
  "glowBackground": "AutomationsModule-module__OHvQ-q__glowBackground",
  "lastNode": "AutomationsModule-module__OHvQ-q__lastNode",
  "nodeBody": "AutomationsModule-module__OHvQ-q__nodeBody",
  "nodeHeader": "AutomationsModule-module__OHvQ-q__nodeHeader",
  "nodeIcon": "AutomationsModule-module__OHvQ-q__nodeIcon",
  "nodeParam": "AutomationsModule-module__OHvQ-q__nodeParam",
  "nodeTitle": "AutomationsModule-module__OHvQ-q__nodeTitle",
  "paramLabel": "AutomationsModule-module__OHvQ-q__paramLabel",
  "paramValue": "AutomationsModule-module__OHvQ-q__paramValue",
  "peekAlert": "AutomationsModule-module__OHvQ-q__peekAlert",
  "phoneAvatar": "AutomationsModule-module__OHvQ-q__phoneAvatar",
  "phoneChat": "AutomationsModule-module__OHvQ-q__phoneChat",
  "phoneContainer": "AutomationsModule-module__OHvQ-q__phoneContainer",
  "phoneHeader": "AutomationsModule-module__OHvQ-q__phoneHeader",
  "phoneInputBar": "AutomationsModule-module__OHvQ-q__phoneInputBar",
  "phoneInputFake": "AutomationsModule-module__OHvQ-q__phoneInputFake",
  "phoneMicBtn": "AutomationsModule-module__OHvQ-q__phoneMicBtn",
  "phoneMockup": "AutomationsModule-module__OHvQ-q__phoneMockup",
  "phoneScreen": "AutomationsModule-module__OHvQ-q__phoneScreen",
  "popIn": "AutomationsModule-module__OHvQ-q__popIn",
  "sectionHeader": "AutomationsModule-module__OHvQ-q__sectionHeader",
  "subtitle": "AutomationsModule-module__OHvQ-q__subtitle",
  "title": "AutomationsModule-module__OHvQ-q__title",
  "typingBlink": "AutomationsModule-module__OHvQ-q__typingBlink",
  "typingIndicator": "AutomationsModule-module__OHvQ-q__typingIndicator",
});
